import React from "react";
import { Provider } from "react-redux";
import { configureStore } from '@reduxjs/toolkit'
import rootReducer from ".";

// Exported so non-React code can dispatch — handleGoToCourseClick in
// utils/services/methods.js raises the name gate from outside the tree.
export const store = configureStore({reducer: rootReducer})

export default ({ element }) => (
  <Provider store={store}>{element}</Provider>
);
